import  { useState } from "react";
import PropTypes from "prop-types";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import WebIcon from "@/components/common/Web_Icons";
import { RightOutlined } from "@/config/antd";
import { logout } from "@/store/redux/slices/auth/auth_slice";
import { clearAccessToken } from "@/utils/token_functions";
import NotificationPreferenceModal from "@/pages/settings/components/notification_preference/Notofication_Preference_Modal";
import SocialMediaAccountModal from "@/pages/settings/components/social_media_account/Social_Media_Account_Modal";
import ThemeModal from "@/pages/settings/components/theme/Theme_Modal";
import "@/assets/styles/settings.css";

const SettingsOption = ({ option }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [showSocialMediaModal, setShowSocialMediaModal] = useState(false);
  const [showThemeModal, setShowThemeModal] = useState(false);

  // Check if this option is active based on the current path
  const isModal = ["notifications", "social", "theme"].includes(option.id);
  const currentPath = location.pathname;

  // Make "general" active when on main settings page or explicitly on general settings page
  const isActive =
    !isModal &&
    (currentPath.includes(`/settings/${option.id}`) ||
      (option.id === "general" &&
        (currentPath === "/dashboard/settings" ||
          currentPath === "/settings")));

  const handleLogout = () => {
    dispatch(logout());

    // Clear access tokens and cookies
    clearAccessToken();

    navigate("/signin");
  };

  const handleClick = () => {
    if (option.id === "logout") {
      handleLogout();
    } else if (option.id === "notifications") {
      setShowNotificationModal(true);
    } else if (option.id === "social") {
      setShowSocialMediaModal(true);
    } else if (option.id === "theme") {
      setShowThemeModal(true);
    } else if (option.id === "support") {
      navigate(`/dashboard/settings/help/faq/${option.id}`);
    } else if (option.id === "legal") {
      window.open(
        "https://tech.veegil.com/campaign-management/privacy-policy/",
        "_blank"
      );
    } else {
      navigate(`/dashboard/settings/${option.id}`);
    }
  };

  return (
    <>
      <div
        className={`flex items-center p-3 rounded-lg cursor-pointer hover:bg-[var(--header-bg)]`}
        onClick={handleClick}>
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 flex items-center justify-center">
            <WebIcon
              icon={option.icon}
              className={`w-6 h-6 ${
                isActive ? "settings-active-icon" : "web-icon-light"
              }`}
            />
          </div>
          <div className="text-left">
            <h3
              className={`text-bold ${
                isActive ? "text-primary" : "text-black"
              }`}>
              {option.title}
            </h3>
            <p className="text-small dark-mode-text">{option.description}</p>
          </div>
        </div>
        <RightOutlined className="text-secondary ml-auto" />
      </div>

      {/* Notification Preference Modal */}
      <NotificationPreferenceModal
        isVisible={showNotificationModal}
        onClose={() => setShowNotificationModal(false)}
      />

      {/* Social Media Account Modal */}
      <SocialMediaAccountModal
        isVisible={showSocialMediaModal}
        onClose={() => setShowSocialMediaModal(false)}
      />

      {/* Theme Modal */}
      <ThemeModal
        isVisible={showThemeModal}
        onClose={() => setShowThemeModal(false)}
      />
    </>
  );
};

SettingsOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.string,
  }),
};

export default SettingsOption;
